import React from "react";
import { BrowserRouter } from "react-router-dom";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import FacilitySection from "./components/FacilitySection";
import ProcessSection from "./components/ProcessSection";
import ProductsSection from "./components/ProductsSection";
import Footer from "./components/Footer";
import Contact from "./components/Contact";

export default function App() {
    return (
        <BrowserRouter>

            <div className="min-h-screen w-full overflow-x-hidden bg-background font-sans text-foreground">

                <Nav />

                <main className="w-full pt-[72px]">

                    <section id="home">
                        <Hero />
                    </section>

                    <section id="facility">
                        <FacilitySection />
                    </section>

                    <section id="process">
                        <ProcessSection />
                    </section>

                    <section id="products">
                        <ProductsSection />
                    </section>

                    <section id="contact">
                        <Contact />
                    </section>

                </main>

                <Footer />

            </div>

        </BrowserRouter>
    );
}